import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### フォント API 操作クラス
 */
export default class Fonts {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET Fonts
   */
  public async getPdfFont(userStore: LoginUser): Promise<Blob> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.PdfFont, formatParams);
    const response = await this.commonService.executeGet<{ url: string }>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.SYSTEM_ERROR, 0);

    const font = await this.commonService.executeSimpleGet<Blob>(response.data.url, this.constructor.name, {}, HitomeqErrorType.SYSTEM_ERROR, "blob");

    return font.data;
  }
}
